import React, { Component } from "react";
import {
  Drawer,
  Divider,
  Paper,
  RaisedButton,
  TextField,
  SelectField,
  AutoComplete,
  MenuItem,
  FlatButton,
  Dialog,
} from "material-ui";
import Loading from "../Loading";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

export default class EngagementWatcher extends Component {
  componentWillMount() {
    this.props.authFetchWorkorders("documents/watchers", this.props.token.jwt);
  }

  render() {
    let filter = { type: "TextFilter", delay: 500 };

    if (this.props.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      return (
        <Paper
          className="container"
          zDepth={2}
          style={{ marginTop: "2em", paddingTop: "1em" }}
        >
          <center>
            <h3>Engagement Letter Document Watcher</h3>
          </center>
          <BootstrapTable data={this.props.workOrders} pagination>
            <TableHeaderColumn
              dataField="client_id"
              dataSort
              filter={filter}
              isKey
              width="125"
            >
              Client ID
            </TableHeaderColumn>
            <TableHeaderColumn dataField="type" dataSort filter={filter}>
              Document Type
            </TableHeaderColumn>
            <TableHeaderColumn dataField="client_name" dataSort filter={filter}>
              Client Name
            </TableHeaderColumn>
          </BootstrapTable>
        </Paper>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./app/components/documents/EngagementWatcher.js